var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccFastFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fast_food_restaurants",
    "data-name": "Fast food restaurants",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8398",
    "data-name": "Rectangle 8398",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35258",
    "data-name": "Group 35258",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35900",
    "data-name": "Path 35900",
    d: "M7.665,8.225,4.3,20.766c-.363,1.363-.727,2.726-1.181,4.09,1.272-.363,2.454-.727,3.726-1.091l13-3.635c-.181-7.089-5.089-11.815-12.178-11.9m1,12.359a1.321,1.321,0,0,1-1.363-1.272,1.338,1.338,0,0,1,1.313-1.363h.05a1.321,1.321,0,0,1,1.363,1.272,1.288,1.288,0,0,1-1.208,1.363,1.336,1.336,0,0,1-.155,0m2-5.817a1.338,1.338,0,0,1-1.363-1.313V13.4a1.219,1.219,0,0,1,1.156-1.279,1.2,1.2,0,0,1,.207.007A1.321,1.321,0,0,1,12.032,13.4a1.465,1.465,0,0,1-1.363,1.363m4,3.908A1.321,1.321,0,0,1,13.306,17.4a1.363,1.363,0,0,1,2.726,0,1.382,1.382,0,0,1-1.363,1.272",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35901",
    "data-name": "Path 35901",
    d: "M10.509,3.155a1.374,1.374,0,0,0-1.454,1L8.419,6.427c7.724.181,12.9,5.362,13.177,13l2.272-.636a1.312,1.312,0,0,0,1-1.454A16.141,16.141,0,0,0,10.509,3.159",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccFastFood);
export default __webpack_public_path__ + "static/media/mcc_fastFood.7d956f037b8afe86a73ceaa7e253d815.svg";
export { ForwardRef as ReactComponent };